import {
  AccountBalanceWallet,
  Assignment,
  Cancel,
  Dashboard,
  FileUpload,
  Forum,
  HistoryOutlined,
  HowToReg,
  People,
  Report,
  Verified,
  AttachMoney
} from '@mui/icons-material'
import BusinessIcon from '@mui/icons-material/Business'
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined'
import FormatListBulletedOutlinedIcon from '@mui/icons-material/FormatListBulletedOutlined'
import AutoModeOutlinedIcon from '@mui/icons-material/AutoModeOutlined'
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import VerifiedIcon from '@mui/icons-material/Verified'
import BlockOutlined from '@mui/icons-material/BlockOutlined'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import UpdateIcon from '@mui/icons-material/Update'
import CompareArrowsIcon from '@mui/icons-material/CompareArrows'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'
import PolicyIcon from '@mui/icons-material/Policy'
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import { MdSupportAgent } from 'react-icons/md'

export const iconMap = {
  Dashboard,
  AttachMoney,
  People,
  HowToReg,
  InsertDriveFileIcon,
  Verified,
  VerifiedIcon,
  FactCheckIcon,
  ManageAccountsIcon,
  FormatListBulletedOutlinedIcon,
  PublishedWithChangesOutlinedIcon,
  AutoModeOutlinedIcon,
  CompareArrowsIcon,
  FileUpload,
  HistoryOutlined,
  Report,
  ReportGmailerrorredIcon,
  AssignmentTurnedInIcon,
  BlockOutlined,
  Assignment,
  AccountBalanceWallet,
  BusinessIcon,
  Forum,
  Cancel,
  PolicyIcon,
  AccountCircleIcon,
  UpdateIcon,
  MdSupportAgent
}
